<template>
  <div class="order-page c-layout">
    <div class="breadcrumbs c-layout hide-on-pad">
      <span>{{ $t('breadcrumbs.home') }}</span>
      <span class="p-16">/</span>
      <span>{{ $t('breadcrumbs.user_center') }}</span>
      <span class="p-16">/</span>
      <span class="o-color">{{ $t('breadcrumbs.custom_order') }}</span>
    </div>
    <div class="page-title">{{ $t('breadcrumbs.custom_order') }}</div>
    <div class="page-container">
      <div class="page-left hide-on-pad">
        <user-side-menu page="customOrder"/>
      </div>
      <div class="page-right ">
        <div class="search-block">
          <select class="light-border" v-model="date">
            <option value="">{{ $t('custom_order.time_range1') }}</option>
            <option value="1">{{ $t('custom_order.time_range2') }}</option>
            <option value="2">{{ $t('custom_order.time_range3') }}</option>
            <option value="3">{{ $t('custom_order.time_range4') }}</option>
            <option value="4">{{ $t('custom_order.time_range5') }}</option>
          </select>
          <div class="btn btn-orange" @click="handleDateSearch">{{ $t('btns.search') }}</div>
        </div>
        <div class="table-list" ref="tableList">
          <div class="table-header hide-on-pad-flex">
            <div class="td date">{{ $t('custom_order.column1') }}</div>
            <div class="td no">{{ $t('custom_order.column2') }}</div>
            <div class="td store">{{ $t('custom_order.column3') }}</div>
            <div class="td process">{{ $t('custom_order.column4') }}</div>
            <div class="td price">{{ $t('custom_order.column5') }}</div>
            <div class="td note">{{ $t('custom_order.column6') }}</div>
          </div>
          <div class="table-body">
            <div class="tr" v-for="item in list" :key="item.no">
              <div class="td date"><span class="td-title show-on-pad">{{ $t('custom_order.column1') }}: </span>{{ item.orderdate }}<span class="span-status show-on-pad">{{ formatPayStatus(item.is_pay) }}</span></div>
              <div class="td no"><span class="td-title show-on-pad">{{ $t('custom_order.column2') }}: </span>{{ item.no }}</div>
              <div class="td store"><span class="td-title show-on-pad">{{ $t('custom_order.column3') }}: </span>{{ item.retailer_name }}</div>
              <div class="td process"><span class="td-title show-on-pad">{{ $t('custom_order.column4') }}: </span>{{ formatProcess(item.process) }}</div>
              <div class="td price"><span class="td-title show-on-pad">{{ $t('custom_order.column5') }}: </span>{{ item.reserveTime }}</div>
              <div class="td note">
                <span class="td-title show-on-pad">{{ $t('custom_order.column7') }}: </span>
                {{ item.note?item.note:'无' }}
                <div class="btn btn-light-orange" @click="handelGoToDetail(item.no)">{{ $t('btns.detail') }}</div>
              </div>
            </div>
            <div class="tr  hide-on-pad">
              {{ $t('custom_order.remark') }}
            </div>
          </div>
        </div>
        <!-- <div class="pagination-block">
          <div class="pagination-tool mr-20  hide-on-pad" :class="{ disabled:listLoading || totalPage<=10 }" @click="goPage(1)">首页</div>
          <div class="pagination-tool  hide-on-pad" :class="{ disabled:listLoading || totalPage<=10 }" @click="goPage(pages-1)">前一页</div>
          <el-pagination
            :page-size="count"
            :pager-count="5"
            layout="pager"
            :current-page="pages"
            :total="totalPage"
            class="custom-pagination"
            :disabled="listLoading"
            @current-change="handelPaginationChange"
          >
          </el-pagination>
          <div class="pagination-tool  hide-on-pad" :class="{ disabled:listLoading || totalPage<=10 }" @click="goPage(pages+1)">下一页</div>
          <div class="pagination-tool ml-20  hide-on-pad" :class="{ disabled:listLoading || totalPage<=10 }" @click="goPage(totalPage/count)">末页</div>
        </div> -->
        <Pagination
          :pageSize="count"
          :pages="pages"
          :total="totalPage"
          :listLoading="listLoading"
          @handelPaginationChange="handelPaginationChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import userSideMenu from '../../components/UserSideMenu'
import Pagination from '../../components/Pagination/NewPagination.vue';
import { getCustomOrderList } from '../../api/index';
import { Loading } from 'element-ui';

  export default {
    name: 'order',
    data() {
      return {
        pages: 0,
        count: 10,
        totalPage: 10,
        date: '',
        list: [],
        gettingList: false,
        listLoading: true,
      }
    },
    components: {
      userSideMenu,Pagination
    },
    filters: {
      
    },
    created() {
      
    },
    mounted() {
      this.$nextTick(() => {
        this.getList();
      });
    },
    methods: {
      formatPayStatus(value) {
        switch(value) {
          case 1:
            return this.$t('format.is_pay');
            break;
          case 2:
            return this.$t('format.not_pay');
            break;
        }
      },
      formatProcess(value) {
        switch(Number(value)) {
          case 1:
            return this.$t('format.process1');
            break;
          case 2:
            return this.$t('format.process2');
            break;
          case 3:
            return this.$t('format.process2');
            break;
          case 4:
            return this.$t('format.process2');
            break;
          case 5:
            return this.$t('format.process2');
            break;
        }
      },
      async getList(options={}) {
        const { index='',clean=false } = options;
        // 下面切换第几页时会自动加pages，所以如果有传index就不要再++了
        if(!index) {
          this.pages++;
        }
        if(clean) {
          this.pages = 1
        }
        const data = {
          pages: this.pages,
          count: this.count,
          date: this.date
        };
        this.listLoading = true;
        console.log(this.$refs.tableList);
        let loadingInstance = Loading.service({ target: this.$refs.tableList });
        const { order,total } = await getCustomOrderList(data);
        setTimeout(() => {
          this.list = order;
          this.listLoading = false;
          this.totalPage = total;
          console.log('order',order);
          loadingInstance.close();
        }, 1000);

      },
      // goPage(index) {
      //   if(this.listLoading) return; 
      //   if(this.totalPage<=10) return;
      //   if(index<1) index = 1;
      //   if(index>this.totalPage/this.count) index = this.totalPage/this.count;
      //   this.pages = index;
      //   this.getList({index});
      // },
      handelPaginationChange(val) {
        // this.goPage(index);
        this.pages = val;
        this.getList({index:val});
      },
      handleDateSearch() {
        if(this.listLoading) return; 
        this.getList({clean:true});
      },
      handelGoToDetail(no) {
        // this.$router.push({ name: 'customOrderDetail', query: { no } });
        // let routeData = this.$router.resolve({ name: 'customOrderDetail', query: { no } });
        // window.open(routeData.href, '_blank');
        this.$router.push({ name: 'customOrderDetail', query: { no } });
      }
    }
  }
</script>

<style lang="less" scoped>
.order-page {
  @media (max-width: 992px) {
    background: #F7F8FA;
    .page-container {
      padding-top: 0;
    }
  }
  .search-block {
    display: flex;
    margin-bottom: 60px;
    select {
      flex: 1;
    }
    .btn {
      margin-left: 40px;
      width: 120px;
    }
    @media (max-width: 992px) {
      margin-bottom: 20px;
      .btn {
        margin-left: 20px;
        width: 100px;
      }
    }
  }
  .table-list {
    text-align: center;
    .table-header {
      display: flex;
      background: #F0F0F0;
      padding: 10px;
    }
    .table-body {
      display: flex;
      flex-direction: column;
    }
    .tr {
      display: flex;
      padding: 20px 0;
      border-bottom: 1px solid #E6E6E6;
    }
    .date {
      flex: 0 0 19%;
    }
    .no {
      flex: 0 0 19%;
    }
    .store {
      flex: 0 0 19%;
    }
    .process{
      flex: 0 0 14%;
    }
    .price {
      flex: 0 0 14%;
    }
    .note {
      flex: 0 0 15%;
      .btn {
        margin-top: 10px;
      }
    }
    @media (max-width: 992px) {
      text-align: left;
      font-weight: 400;
      .tr {
        flex-direction: column;
        background: white;
        border-bottom: unset;
        // border-radius: 5px;
        margin-bottom: 20px;
        box-shadow: 0 5px 6px #D2D3D7;
        padding: 20px 10px;
        .td {
          color: black;
          margin-bottom: 13px;
          display: flex;
          &:nth-last-child(1) {
            margin-bottom: 0;
          }
          .td-title {
            color: #707070;
            margin-right: 10px;
          }
          &.date {
            .td-title {
              color: black;
            }
            border-bottom: 2px solid #E6E6E6;
            padding-bottom: 10px;
            position: relative;
            .span-status {
              position: absolute;
              right: 10px;
              opacity: .5;
              top: 0px;
            }
          }
          &.note {
            position: relative;
            padding-right: 100px;
            .btn {
              margin-top: 0px;
              position: absolute;
              bottom: 0;
              right: 10px;
              padding: 10px 14px;
              border-radius: 10px;
            }
          }
        }
      }
    }
  }
  .pagination-block {
    padding: 30px 0;
    display: flex;
    justify-content: center;
    .pagination-tool {
      line-height: 28px;
      cursor: pointer;
      font-weight: 500;
      color: #707070;
      &.disabled {
        color: #C0C4CC;
        cursor: not-allowed;
      }
    }
    /deep/ .custom-pagination {
      display: flex;
      justify-content: center;
      li {
        border-radius: 50%;
        min-width: unset;
        width: 28px;
        margin-right: 20px;
        &:nth-child(1) {
          margin-left: 20px;
        }
      }
      li.active,li:hover {
        background: #ec4f00;
        color: white;
      }
    }
  }
}
</style>